import { LabelHelper } from '../helper/label-helper'
import colors from '../../../tokens/colors'

export const Options = (labels: string[]) => {
  const labelHelper = LabelHelper()
  const formatCurrency = labelHelper.formatCurrency()
  const formatDate = labelHelper.formatDate()

  return {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: `${colors.neutralColorHighPure}`,
        titleAlign: 'center',
        bodyAlign: 'center',
        borderColor: `${colors.neutralColorLowLight}`,
        borderWidth: 1,
        titleColor: `${colors.neutralColorLowPure}`,
        bodyColor: `${colors.neutralColorLowPure}`,
        padding: 12,
        cornerRadius: 4,
        displayColors: false,
        caretSize: 0,
        caretPadding: 12,
        callbacks: {
          title: (tooltipItem) =>
            formatCurrency.abbreviated(tooltipItem[0].raw),
          label: (tooltipItem) => formatDate.joinYear(tooltipItem.label),
        },
      },
    },
    scales: {
      y: {
        ticks: {
          callback: (value) => formatCurrency.abbreviated(value),
        },
      },
      x: {
        ticks: {
          callback: (value, index) => {
            return formatDate.abbreviated(labels[index])
          },
        },
      },
    },
  }
}
